







import { Component, Prop, Vue } from 'vue-property-decorator';
import CoordinatorElement from './element'

@Component({
  components: {
    CoordinatorElement
  },
})
export default class DepartmentsBox extends Vue {

  @Prop({ type: Array, default: [] })
  items: [];


}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/footer/coordinators/CoordinatorsBox.vue